export default "__VITE_ASSET__BzoIMeKE__"